import React, { Component } from 'react';
import { Text, TextInput } from 'grommet';
import Button from '@mui/material/Button';
import { css } from 'emotion';
import BriteTextInput from './inputs/BriteTextInput';
import { motion } from 'framer-motion';

export class DecisionToolUrgentCareQuestion extends Component {
  render() {
    return (
      <motion.div
        key={`urgent_question${this.props.type}`}
        initial="pageInitial"
        animate="pageAnimate"
        exit="pageExit"
        variants={{
          pageInitial: {
            y: 400,
            opacity: 0,
          },
          pageAnimate: {
            y: 0,
            opacity: 1,
          },
          pageExit: {
            y: -400,
            opacity: 0,
          },
        }}
        className={css`
          background: #ffffff;

          box-shadow: 0px 2px 8px rgba(37, 40, 45, 0.25);
          border-radius: 8px;
          padding: 24px;
          margin-bottom: 32px;
          text-align: left;
        `}
      >
        <h1
          className={css`
            color: #25282d;
            font-size: 23px;
            line-height: 32px;
            margin-block-start: 0px;
            margin-block-end: 12px;
          `}
        >
          {' '}
          {this.props.type === 'personal'
            ? 'How many visits have you had in the last year?'
            : 'How many visits have your dependents had in the last year?'}{' '}
        </h1>

        {this.props.shouldDisplayDependentQuestions && (
          <div
            className={css`
              font-family: 'Roboto';
              font-style: normal;
              font-weight: 700;
              font-size: 18px;
              line-height: 24px;
              /* identical to box height, or 133% */

              letter-spacing: 0.15px;

              color: #25282d;
              margin-top: 16px;
            `}
          >
            For you
          </div>
        )}

        <div
          className={css`
            display: flex;
            justify-content: space-between;
            align-items: center;

            flex-wrap: wrap;
          `}
        >
          <div
            className={css`
              margin-top: 16px;
            `}
          >
            <BriteTextInput
              placeholder="# of urgent care visits"
              value={this.props.numberUrgentVisits}
              id="urgent-care-input"
              label="Urgent Care"
              variant="outlined"
              type="number"
              inputProps={{ inputMode: 'numeric' }}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  this.props.setUrgentCareVisits(e.target.value);
                }
              }}
            />
          </div>

          <div
            className={css`
              margin-top: 16px;
            `}
          >
            <BriteTextInput
              placeholder="# of er visits"
              value={this.props.numberERVisits}
              id="ER-input"
              label="ER"
              variant="outlined"
              type="number"
              inputProps={{ inputMode: 'numeric' }}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  this.props.setERVisits(e.target.value);
                }
              }}
            />
          </div>
        </div>

        {this.props.shouldDisplayDependentQuestions && (
          <>
            <div
              className={css`
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 700;
                font-size: 18px;
                line-height: 24px;
                /* identical to box height, or 133% */

                letter-spacing: 0.15px;

                color: #25282d;
                margin-top: 24px;
              `}
            >
              For your dependents
            </div>

            <div
              className={css`
                display: flex;
                justify-content: space-between;
                align-items: center;

                flex-wrap: wrap;
              `}
            >
              <div
                className={css`
                  margin-top: 16px;
                `}
              >
                <BriteTextInput
                  placeholder="# of urgent care visits"
                  value={this.props.dependantUrgentCareVisits}
                  id="urgent-care-input"
                  label="Urgent Care"
                  variant="outlined"
                  type="number"
                  inputProps={{ inputMode: 'numeric' }}
                  onChange={(e) => {
                    if (e.target.value >= 0) {
                      this.props.setDependantUrgentCareVisits(e.target.value);
                    }
                  }}
                />
              </div>

              <div
                className={css`
                  margin-top: 16px;
                `}
              >
                <BriteTextInput
                  placeholder="# of er visits"
                  value={this.props.dependantERVisits}
                  id="ER-input"
                  label="ER"
                  variant="outlined"
                  type="number"
                  inputProps={{ inputMode: 'numeric' }}
                  onChange={(e) => {
                    if (e.target.value >= 0) {
                      this.props.setDependantERVisits(e.target.value);
                    }
                  }}
                />
              </div>
            </div>
          </>
        )}
        <div
          className={css`
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 24px;
            /* identical to box height, or 200% */

            letter-spacing: 0.15px;

            color: #9aa7b5;
            margin-top: 16px;
          `}
        >
          {this.props.questionDisclaimerText}
        </div>
      </motion.div>
    );
  }
}
